var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z",
    transform: "translate(-456.000000, -429.000000) translate(448.000000, 421.000000) translate(8.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7A7A",
    stroke: "#FFF",
    strokeWidth: 2.7,
    d: "M16.648 14.002c-.95-2.69-3.75-4.5-6.88-3.88-2.29.46-4.15 2.29-4.63 4.58-.82 3.87 2.12 7.3 5.86 7.3 2.61 0 4.83-1.67 5.65-4h4.35v2c0 1.1.9 2 2 2s2-.9 2-2v-2c1.1 0 2-.9 2-2s-.9-2-2-2h-8.35zm-5.65 4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
    transform: "translate(-456.000000, -429.000000) translate(448.000000, 421.000000) translate(8.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/IconPassword.6604fceef13650de003b8b36d18c0fcf.svg";
export { ForwardRef as ReactComponent };